__turbopack_context__.v({
  "button": "SRdWBq_button",
  "hidden": "SRdWBq_hidden",
  "icon": "SRdWBq_icon",
  "inputWrapper": "SRdWBq_inputWrapper",
  "onlyLargeFields": "SRdWBq_onlyLargeFields",
  "spaceWrapper": "SRdWBq_spaceWrapper",
});
